import { computed, ref } from 'vue';

import type { InjectionWithDefaults } from '../../../types/utils';
import type { ThumbnailDefinition } from '../Thumbnail/Thumbnail.types';
import type { ThumbnailInjection, ThumbnailRadius } from './ThumbnailGroup.types';

// See: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
export const THUMBNAIL_INJECTION: InjectionWithDefaults<ThumbnailInjection<ThumbnailDefinition>> = Object.freeze({
  key: Symbol('THUMBNAIL_INJECTION_KEY'),
  defaults: Object.freeze({
    radius: 'rounded' as ThumbnailRadius,
    draggable: computed(() => false),
    removable: computed(() => false),
    thumbnails: computed(() => [] as ThumbnailDefinition[]),
    activeThumbnail: ref(undefined),
    isDragging: ref(false),
  }),
});
